module.exports = __webpack_public_path__ + "img/fondoopacity.10c9b0ec.svg";